import React, { useEffect, useState, useRef } from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { tableIcons } from "../../../../Utilities/Utility";
import { tableOptionsUser } from "../../../../Themes/LightTheme";
import { useSelector } from "react-redux";
import SnackbarCustom from "../../../../Components/Snackbar/Snackbar";
import { addSupplierAPI, getSupplierMaster,updateSupplierDetails,deleteSupplierDetails} from "../../../../Redux/APIs/api_MasterData";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { DeleteOutlined } from "@material-ui/icons";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export default function SupplierMaster() {
    
    const tableRef = useRef();
    const userDetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    const [tableData, setTableData] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const [rowData,setRowData] = useState();
    const [isEditMode, setIsEditMode] = useState(false);

    // New
    const [openForm, setOpenForm] = useState(false);
    const [formDialogTitle, setFormDialogTitle] = useState("Add");
     const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
     const [deleteRowData, setDeleteRowData] = useState(null);

    const handleSnackOpen = (text, type) => {
        setSnackMessage(text);
        setAlertType(type);
        setOpen(true);
    };
    const handleClose = (e) => {
        setOpen(false);
    };

    const handleCloseDeleteDialog = () => {
        setDeleteDialogOpen(false);
        setDeleteRowData(null);
    };
    //azure ad
    const siteToken = useSelector((state) => state.saveBearerTokenReducer);
    const azureToken = useSelector((state) => state.saveTokenReducer);
    const UID = useSelector((state) => state.saveUserIdReducer);
    function isRoleExists(value) {
        const obj = tableData.find((c) => c.roleName == value);
        return obj ? true : false;
    }
    function isRoleExists(value, id) {
        const obj = tableData.find((c) => c.roleName == value);
        return obj && obj.roleId !== id ? true : false;
    }
    function validateRole(value, id) {
        return !value
            ? { isValid: false, helperText: "*Required" }
            : (!id && isRoleExists(value)) || (id && isRoleExists(value, id))
                ? { isValid: false, helperText: "Already exists" }
                : { isValid: true, helperText: "" };
    }
    const columns = [
        { title: 'Supplier Id', field: 'code' },
        {
            title: 'Supplier Name', field: 'name',
            validate: (rowData) =>
                validateRole(rowData.roleName, rowData.roleId),
        },
        { title: 'Supplier Email', field: 'email' },

    ];
    function getTableData() {
        setIsLoader(true);
        getSupplierMaster(siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId)
            .then((response) => {
                setTableData(response);
                setIsLoader(false);
            })
            .catch((error) => {
                handleSnackOpen("Error : " + error, "error");
                setIsLoader(false);
            });
    }
    useEffect(() => {
        getTableData();
    }, [userDetails])

    function GetEditButton() {
        return (
            <Tooltip title="Edit" placement="bottom">
                <span>
                    <Button href="javascript:void(0)">
                        <span>
                            <EditOutlinedIcon fontSize="small" className="attachFileIcon" />
                        </span>
                    </Button>
                </span>
            </Tooltip>
        );
    }
    function GetDeleteButton() {
        return (
            <Tooltip title="Delete" placement="bottom">
                <span>
                    <Button href="javascript:void(0)">
                        <span>
                            <DeleteOutlined fontSize="small" className="attachFileIcon" />
                        </span>
                    </Button>
                </span>
            </Tooltip>
        );
    }

    const [supplierInfo, setSupplierInfo] = useState({
        suppCode: "",
        suppName: "",
        suppEmail:"",
        suppCodeHelpTxt: "Required Field **",
        suppNameHelpTxt: "Required Field **",
        //suppEmailHelpTxt: "Required Field **"
    });

    const handleChange = (e) => {
        console.log(supplierInfo)
        const { name, value } = e.target;
        setSupplierInfo((prevState) => ({
            ...prevState,
            [name]: value,
            ...(value ?
                { [`${name}HelpTxt`]: '' }
                : { [`${name}HelpTxt`]: 'Required Field **' }
            ),
        }));
    }
   

    const handleCloseForm = () => {
        setOpenForm(false);
        setSupplierInfo((prevState) => ({
            ...prevState,
            suppCode: "",
            suppName: "",
            suppEmail:"",
            suppCodeHelpTxt: "Required Field **",
            suppNameHelpTxt: "Required Field **",
            //suppEmailHelpTxt: "Required Field **"
        }));
    };

    const addSupplier = () => {
        console.log("Add supp");

        setIsLoader(true);
        const supplierArgs = {
            SupplierCode: supplierInfo.suppCode,
            SupplierName: supplierInfo.suppName,
            SupplierEmail: supplierInfo.suppEmail,
            LoggedInUserId: 4
        }
        addSupplierAPI(
            siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId, supplierArgs
        ).then((resp) => {
            console.log("Resp", resp)
            // handleCloseForm();
            setIsLoader(false);
            handleSnackOpen("Supplier Added Successfully", 'success');
            getTableData();
        })
            .catch((err) => {
                // handleCloseForm();
                setIsLoader(false);
                handleSnackOpen("Error in adding Supplier", 'error');
                console.log("err", err);
            })
    }
    const updateSupplier = () => {
        console.log("rowdata--nidhi",rowData);
        setIsLoader(true);
        const supplierArgs = {
            SupplierCode: supplierInfo.suppCode,
            SupplierName: supplierInfo.suppName,
            SupplierEmail: supplierInfo.suppEmail,
            SupplierId: rowData.supplierId
        }
        console.log('updated data',supplierArgs)
        updateSupplierDetails(
            siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId, supplierArgs
        ).then((resp) => {
            console.log("Resp", resp)
            // handleCloseForm();
            setIsLoader(false);
            handleSnackOpen(resp.responseMsg, 'success');
            getTableData();
        })
            .catch((err) => {
                // handleCloseForm();
                setIsLoader(false);
                handleSnackOpen("Error in updating Supplier", 'error');
                console.log("err", err);
            })
    }

    const handleDialogRowDelete = () => {
        console.log("delete supp",rowData);
        setIsLoader(true);
        setDeleteDialogOpen(false);
        const supplierArgs = rowData.supplierId
        
        deleteSupplierDetails(
            siteToken.token,
            azureToken.token,
            UID.id,
            userDetails.userEmail,
            userDetails.gid,
            userDetails.role,
            userDetails.roleId,supplierArgs
        ).then((resp) => {
            console.log("Resp", resp)
            // handleCloseForm();
            setIsLoader(false);
            handleSnackOpen(resp.responseMsg, 'success');
            getTableData();
        })
            .catch((err) => {
                // handleCloseForm();
                setIsLoader(false);
                handleSnackOpen("Error in deleting Supplier", 'error');
                console.log("err", err);
            })
    }

    return (
        <div>
            <div className="App">
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <MaterialTable
                            title=""
                            tableRef={tableRef}
                            columns={columns}
                            data={tableData}
                            isLoading={isLoader}
                            icons={tableIcons}
                            options={tableOptionsUser}
                            actions={[
                                {
                                    icon: "add",
                                    isFreeAction: true,
                                    onClick: () => {
                                        setFormDialogTitle("Add");
                                        setIsEditMode(false);
                                        setSupplierInfo({
                                            suppCode: "",
                                            suppName: "",
                                            suppEmail: "",
                                            suppCodeHelpTxt: "Required Field **",
                                            suppNameHelpTxt: "Required Field **",
                                            // Reset all other fields
                                          });
                                        setOpenForm(true);
                                    },
                                },
                                {
                                    icon: GetEditButton,
                                    tisFreeAction: true,
                                    onClick: (e, rowData) => {
                                        setFormDialogTitle("Update");
                                        setIsEditMode(true);
                                        setSupplierInfo({
                                            suppCode: rowData.code || "",
                                            suppName: rowData.name || "",
                                            suppEmail: rowData.email || "",
                                            suppCodeHelpTxt: "Required Field **",
                                            suppNameHelpTxt: "Required Field **",
                                            // Add other fields if any
                                          });
                                        setOpenForm(true);
                                        console.log("Row Data", rowData);
                                        setRowData(rowData);
                                        // dialogDraftValuesFn(rowData);
                                    },
                                },
                                {
                                    icon: GetDeleteButton,
                                    tisFreeAction: true,
                                    onClick: (e, rowData) => {
                                        setDeleteDialogOpen(true)
                                        console.log("Row Data delete", rowData);
                                        setRowData(rowData);
                                        // handleDeleteIconClick(rowData);
                                    },
                                },
                            ]}
                        />
                        <>
                            <SnackbarCustom
                                open={open}
                                message={snackMessage}
                                alertType={alertType}
                                handleClose={handleClose}
                            />
                        </>
                    </Grid>
                </Grid>
            </div>

            <Dialog
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseForm();
                    }
                }}
                aria-labelledby="litigation-form--registration"
                open={openForm}
                maxWidth={"lg"}
                disableEscapeKeyDown
            >
                <DialogTitle id="responsive-dialog-title"> {formDialogTitle === "Add" ? "Add Supplier" : "Update Supplier"}</DialogTitle>
               
                <div style={{ position: "absolute", right: "1%" }}>
                    <Tooltip title="Close">
                        <IconButton onClick={handleCloseForm}>
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    className=""
                                    fullWidth
                                    name="suppCode"
                                    label="Supplier Code"
                                    variant="filled"
                                    value={supplierInfo.suppCode}
                                    helperText={supplierInfo.suppCodeHelpTxt}
                                    onChange={handleChange}
                                    id="suppCode"
                                    disabled={isEditMode}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    className=""
                                    fullWidth
                                    name="suppName"
                                    label="Supplier Name"
                                    variant="filled"
                                    value={supplierInfo.suppName}
                                    helperText={supplierInfo.suppNameHelpTxt}
                                    onChange={handleChange}
                                    id="suppName"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    className=""
                                    fullWidth
                                    name="suppEmail"
                                    label="Supplier Email"
                                    variant="filled"
                                    value={supplierInfo.suppEmail}
                                   // helperText={supplierInfo.suppEmailHelpTxt}
                                    onChange={handleChange}
                                    id="suppEmail"
                                />
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="submit"
                        fullWidth
                        className="pt-button--secondary"
                        id="addSupplier"
                        onClick={
                            formDialogTitle === "Add" ? () => {
                                handleCloseForm();
                                setIsLoader(true);
                                addSupplier();
                            } : () => {
                                handleCloseForm();
                                setIsLoader(true);
                                updateSupplier();
                            }
                        }
                    >
                        {formDialogTitle}
                    </Button>
                </DialogActions>
            </Dialog>

              <Dialog
                            open={deleteDialogOpen}
                            onClose={handleCloseDeleteDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="responsive-dialog-title">Delete Supplier</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure to Delete this Supplier?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleDialogRowDelete}
                                    className="pt-button--primary"
                                >
                                    Ok
                                </Button>
                                <Button
                                    onClick={handleCloseDeleteDialog}
                                    className="pt-button--secondary"
                                    autoFocus
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>

        </div>
    );
}